import { DirectUpload } from "activestorage";
import i18next from "i18next";
import moment, { Moment } from "moment-timezone";
import "moment/locale/ar-ly";
import toast from "react-hot-toast";
import { ApiResponse } from "../api/apiResponse";
import { AppApiURL } from "../api/helpers/apiUrl";
import BaseModel from "../api/models/BaseModel";
/*
  ar-ly locale is the same as ar locale exept that ar-ly uses these number symbols [1234567890] insted of [١٢٣٤٥٦٧٨٩٠],
  Which are aligned with design on figma
*/
moment.defineLocale("ar", {
  parentLocale: "ar-ly",
});

export const ChangeLanguageDocumentAttributes = () => {
  document.documentElement.dir = i18next.dir();
  document.documentElement.lang = i18next.language;
  moment.locale(i18next.language);
};
export const ChangeLanguage = (langKey: "ar" | "en") => {
  i18next
    .changeLanguage(langKey)
    .then(() => ChangeLanguageDocumentAttributes());
  moment.locale(langKey);
};

export function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export function localeMoment(date: Moment) {
  return moment(date).locale(i18next.language);
}

export const onDirectUpload = async (
  file: File,
  onUpload: any,
  setBlob?: any
) => {
  const upload = new DirectUpload(file, AppApiURL.directUploadFullURL);

  upload.create((error: any, blob: any) => {
    if (error) {
      console.log(error);
    } else {
      onUpload(blob.signed_id);
      if (!!setBlob) {
        setBlob(blob);
      }
    }
  });
};

export const showApiErrorMessages = (response: ApiResponse) => {
  response.errorMessages.forEach((errorMessage) => {
    toast.error(errorMessage);
  });
};

export const makeApiRequest = async (
  endpointFunction: () => Promise<ApiResponse>,
  onSuccess: Function
) => {
  const response = await endpointFunction();
  if (response.isSuccess) {
    onSuccess(response);
    return;
  }
  showApiErrorMessages(response);
};

export const getNameParts = (fullName?: string) => {
  let [firstName, middleName, lastName] = ["", "", ""];

  const name = fullName?.split(" ");
  if (name?.length === 1) {
    firstName = name[0];
  } else if (name?.length === 2) {
    firstName = name[0];
    lastName = name[1];
  } else if (name?.length! >= 3) {
    // Some names may have compound names like "Abd El-khalek" which make the total length exceeds 3
    const [_firstName, _middleName, ..._lastName] = name!;
    firstName = _firstName;
    middleName = _middleName;
    lastName = _lastName.join(" ");
  }
  return [firstName, middleName, lastName];
};

export function isNamePartBlank(namePart: string | null | undefined): boolean {
  return namePart === undefined || namePart === null;
}

export const filterEmptyParams = (obj: { [key: string]: any }) => {
  const entries = Object.entries(obj).filter(([key, val]) => !!val);
  return Object.fromEntries(entries);
};

/**
 * FN to get uniques lists of data
 *
 */
export function getUniqueDataList<T>(lists: T[]): T[] {
  let uniqueObjArray = new Map(
    lists.map((item: any) => [item["id"], item])
  ).values();
  return Array.from(uniqueObjArray);
}

export function constraint(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}
export const statusCheckBox = Object.freeze({
  unchecked: 0,
  checked: 1,
  indeterminate: -1,
});
